import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserInfo } from '../api/types';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: UserInfo | null;
  setTokens: (a: string, r: string) => void;
  setUser: (u: UserInfo | null) => void;
  setSession: (a: string, r: string, u: UserInfo) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      setTokens: (a, r) => set({ accessToken: a, refreshToken: r }),
      setUser: (u) => set({ user: u }),
      setSession: (a, r, u) => set({ accessToken: a, refreshToken: r, user: u }),
      clear: () => set({ accessToken: null, refreshToken: null, user: null }),
    }),
    { name: 'flotillas-auth' }
  )
);

export function hasAnyRole(user: UserInfo | null, ...roles: string[]): boolean {
  if (!user) return false;
  return user.roles.some((r) => roles.includes(r));
}
